export function resolveMicroLabAdminMenuSelectedKeys(pathname: string): string[] {
  if (pathname === "/schemes/reviews") {
    return ["/schemes/reviews"];
  }
  if (pathname.startsWith("/schemes/")) {
    return ["/schemes"];
  }
  if (pathname.startsWith("/releases/")) {
    return ["/releases"];
  }
  if (pathname === "/members" || pathname === "/schemes" || pathname === "/releases" || pathname === "/runs") {
    return [pathname];
  }
  return [];
}
